import { ReactComponent as WorkInProgressSVG } from "../../app/assets/icons/work-in-progress.svg";
import CustomButton from "../CustomButton/CustomButton";

interface NoGridDataProps {
  buttonLabel?: string;
  tableHeadersLength: number;
  mainText: string;
  subText?: string;
  handleClick?: () => void;
}

const NoGridData = ({
  buttonLabel,
  tableHeadersLength,
  mainText,
  subText,
  handleClick,
}: NoGridDataProps) => {
  const disable = false;
  return (
    <tr>
      <td colSpan={tableHeadersLength} className="text-center">
        <WorkInProgressSVG />
        <h6 className={`fs-14 fw-500 text-center ${!subText ? "mb-3" : ""}`}>
          {mainText}
        </h6>

        {subText && (
          <h6 className="fs-14 fw-500 text-center mb-3">{subText}</h6>
        )}

        {buttonLabel && handleClick && (
          <CustomButton
            isSubmitting={false}
            label={buttonLabel}
            customClass="w-11rem px-1 py-0 m-0 mb-3 h-48 fs-6"
            onClick={handleClick}
            disabled={disable}
          />
        )}
      </td>
    </tr>
  );
};

export default NoGridData;
